import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Globals } from '@core/globals';
import { ContactCardsSliderComponent } from '@molecules/contact-cards-slider/contact-cards-slider.component';
import { ContactCardsSliderItemComponent } from '@molecules/contact-cards-slider/contact-cards-slider-item/contact-cards-slider-item.component';
import { ContactCardsItem } from '@models/contact-cards.model';

@Component({
  selector: 'app-car-detail-contact-cards',
  imports: [ContactCardsSliderComponent, ContactCardsSliderItemComponent],
  templateUrl: './car-detail-contact-cards.component.html',
  styleUrl: './car-detail-contact-cards.component.scss',
})
export class CarDetailContactCardsComponent implements OnInit {
  public activatedRoute = inject(ActivatedRoute);
  private destroyRef: DestroyRef = inject(DestroyRef);
  public globals = inject(Globals);
  public data?: ContactCardsItem[];

  ngOnInit(): void {
    this.activatedRoute.data.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response) => {
      const data = response['contactCards'];
      this.data = data.sales;
    });
  }
}
